import * as React from 'react';

import {colors} from 'shells/colors/colors';
// @ts-expect-error - imported from .js/.jsx file
import {SolidClockIcon} from 'shells/icon/svg/solid-clock-icon';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {StatusDot} from 'shells/status-selector/status-dot';
import {Switch} from 'shells/switch/switch';
import {Body} from 'shells/typography/body';

import type {AgentStatusEnum} from 'nutshell-graphql-types';
import type {GetSessionUser_loggedInUser as User} from 'nutshell-graphql-types';

import {useUpdateAgentStatus} from '../../../inbox/chat/graphql/hooks';
import {getChatStatusText, getChatStatusDescription} from '../../../sidebar/helpers';

import styles from './chat-status-button.module.css';

type Props = {
    user: User;
    showDisabledUntil?: boolean;
};

export function ChatStatusButton(props: Props) {
    const [currentStatus, setCurrentStatus] = React.useState<AgentStatusEnum>(
        props.user.agentStatus
    );
    const {updateAgentStatus} = useUpdateAgentStatus();

    const handleStatusChange = (status: AgentStatusEnum) => {
        const agentStatus = status === 'ONLINE' ? 'ONLINE' : 'NOT_ACCEPTING_CHATS';
        updateAgentStatus({agentStatus, userId: props.user.id});
        setCurrentStatus(status);
    };

    const isOnline = currentStatus === 'ONLINE';

    return (
        <div className='px-16 py-12 pb-8 flex flex-dir-col gap-4'>
            <StackLegacy isHorizontal={true} alignCenter={true} spacing={4}>
                <StackLegacy isHorizontal={true} spacing={4}>
                    <div className='mr-4 mt-4'>
                        <StatusDot color={isOnline ? colors.success : colors.greyLt} />
                    </div>
                    <div className='flex flex-dir-col gap-4 text-align-left mr-8'>
                        <Body isBold={true}>{getChatStatusText(currentStatus)}</Body>
                        <Body size='small' color='light'>
                            {getChatStatusDescription(currentStatus)}
                        </Body>
                    </div>
                </StackLegacy>
                <Switch
                    isOn={isOnline}
                    onChange={() => handleStatusChange(isOnline ? 'NOT_ACCEPTING_CHATS' : 'ONLINE')}
                    isRounded={true}
                    isSmall={true}
                />
            </StackLegacy>
            {props.showDisabledUntil && (
                <div className={styles['disabled-until-tomorrow-container']}>
                    <SolidClockIcon wrapWithDiv={false} size={12} color={colors.white} />
                    <Body size='small' color='white'>
                        Disabled until tomorrow
                    </Body>
                </div>
            )}
        </div>
    );
}
